import React, { Component } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

// To handle requests
import AccountsAPI from '../utils/AccountsAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
import { namespace } from '../../../config.json';

class DeleteAccountButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
        });
    }

    // Fired when modal is submitted
    submit() {
        this.setState({ inProgress: true });
        // Launching delete account action
        AccountsAPI.deleteAccount(this.props.username).then(() => {
            this.closeModal();
            this.setState({ inProgress: false });
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
        }).then(() =>
            AccountsAPI.deleteUserForAccount(this.props.username,
                window.location.hostname))
        .catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                     server returned an Internal Error.`,
                });
            }
            // Catch error message to display it to users
            this.setState({
                errorText: message.response.body.error,
                inProgress: false,
            });
        });
    }

    render() {
        let errorTag;

        if (this.state.errorText) {
            errorTag = <div className="alert alert-danger">
                {this.state.errorText}
            </div>;
        }

        const buttonTooltip = (
          <Tooltip id="tooltip">
            {'Delete account'}
          </Tooltip>
        );


        return (
          <OverlayTrigger
            placement="top"
            overlay={buttonTooltip}
          >
            <button
              className="btn btn-primary btn-xs delete-user-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}>
                <i className="fa fa-times"></i>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-edit"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Delete account
                            <span>&nbsp;</span>
                            {this.props.username}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <p>Are you sure you want to delete account
                            <strong>&nbsp;{this.props.username}</strong>
                            ?
                        </p>
                        <div className="alert alert-warning">
                            <strong>
                                <i className="fa fa-exclamation-triangle"

                                style={{
                                    color: 'orange',
                                }}></i>
                                <span>&nbsp;</span>
                                This cannot be undone</strong>
                        </div>
                        {errorTag}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.submit}
                          disabled={this.state.inProgress}
                        >
                            Proceed
                        </button>
                        <button className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

// Username is mandatory for delete operation to work
DeleteAccountButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default DeleteAccountButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DeleteAccountButton.js
 **/